import React from 'react';
import { CloseableModal } from '../../../../../components/CloseableModal';
import { ModalBody } from './ModalBody';

interface PropTypes {
  name: string;
  token: string;
  onSubmit: (name: string) => Promise<void>;
  onClose: (succeeded?: boolean) => void;
}

export function EditAPIKeyNameModal({
  name,
  token,
  onSubmit,
  onClose,
}: PropTypes) {
  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={onClose}
      isOpen={true}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle='Edit Key Name'
      bodyChildren={
        <ModalBody
          name={name}
          token={token}
          onSubmit={onSubmit}
          onClose={onClose}
        />
      }
    />
  );
}
